import styled from 'styled-components'
import { Card as AntCard, Button as AntButton, Typography } from 'antd'
import { COLORS, SPACING, TYPOGRAPHY } from '../../../styles/theme'

/**
 * Styled components for MindmapTable
 * Replaces inline styles with reusable, semantic components
 */

const { Text, Title } = Typography

// MindmapCard components
export const StyledCard = styled(AntCard)`
  height: 100%;

  .ant-card-body {
    padding: ${SPACING.lg};
    height: 100%;
  }
`

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${SPACING.md};
`

export const TitleContainer = styled.div`
  flex: 1;
  min-width: 0;
`

export const CardTitle = styled(Title)`
  &.ant-typography {
    margin: 0;
    margin-bottom: ${SPACING.xs};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
` as typeof Title

export const UpdatedText = styled(Text)`
  &.ant-typography {
    font-size: ${TYPOGRAPHY.body.fontSize};
    color: ${COLORS.textSecondary};
  }
` as typeof Text

export const MoreIconButton = styled(AntButton)`
  &.ant-btn {
    flex-shrink: 0;
  }

  .anticon {
    color: ${COLORS.textSecondary};
  }
`

// Search empty state
export const SearchEmptyContainer = styled.div`
  text-align: center;
  padding: 48px 0;
`

// Empty state components
export const EmptyContainer = styled.div`
  padding: 48px 0;
  text-align: center;
`

export const EmptyDescription = styled.div`
  margin-top: ${SPACING.sm};
`

export const EmptyTitle = styled(Text)`
  &.ant-typography {
    font-size: ${TYPOGRAPHY.body.fontSize};
    display: block;
    margin-bottom: ${SPACING.sm};
  }
` as typeof Text

export const EmptySubtitle = styled(Text)`
  &.ant-typography {
    font-size: ${TYPOGRAPHY.body.fontSize};
  }
` as typeof Text

export const CreateProjectButton = styled(AntButton)`
  &.ant-btn {
    margin-top: ${SPACING.lg};
    height: 48px;
    padding-inline: ${SPACING.xxl};
    font-size: ${TYPOGRAPHY.body.fontSize};
  }
`

// Grid container
export const MindmapGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: ${SPACING.lg};
  max-width: 100%;
`
